export const DOWNLOAD_CRAFT_MODS_APPLE_PATH = 'https://apps.apple.com/us/app/mods-for-minecraft-craft-mods/id1615405964';
export const DOWNLOAD_CRAFT_MODS_GOOGLE_PATH = 'https://play.google.com/store/apps/details?id=com.xiaoruo.craftmods';

export const DOWNLOAD_TUBE_CUT_APPLE_PATH = 'https://apps.apple.com/us/app/thumbnail-maker-tubecut/id1634152520';

export const DEVICE_TYPE_ENUM = { UNKNOWN: 0, APPLE: 1, NOT_APPLE: 2, WINDOW: 3, ANDROID: 4, IOS: 5 };
